import { render, staticRenderFns } from "./taxQuitWagesList.vue?vue&type=template&id=a628c984&scoped=true&"
import script from "./taxQuitWagesList.vue?vue&type=script&lang=js&"
export * from "./taxQuitWagesList.vue?vue&type=script&lang=js&"
import style0 from "./taxQuitWagesList.vue?vue&type=style&index=0&id=a628c984&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a628c984",
  null
  
)

export default component.exports